<!-- ************************************************************************************************* -->
<waitLoading *ngIf="!isLoaded()"></waitLoading>
<!-- ************************************************************************************************* -->
<div class="wrapper wrapper-content ng-scope animated fadeInRight" *ngIf="isLoaded()">

  <div class="row m-t-md">
    <div class="col-12">
      <p-panel>
        <p-header>
          <span> <i class="fa fa-file" aria-hidden="true"></i> {{'General.filters'|translate}}</span>
        </p-header>
        <div class="row">
          <div class="col-12">
            <formPlyca #formPlycaRef1 [formConfig]="formConfig1" *ngIf="formConfig1" [manageWaitService]=false>
            </formPlyca>
          </div>

          <div class="col-12 text-right"><button class="btn btn-primary fadeInRight" (click)=" loadSubstitutions()"><i
                class="fas fa-search"></i> {{'General.search.text'|translate}}</button>
          </div>
        </div>
      </p-panel>
    </div>
  </div>


  <div>
    <div class="row m-t-md">
      <div class="col-12">
        <p-panel>
          <p-header>
            <span class="label label-default float-right" style="font-size: small;font-weight: 500;">{{ 'Tasks.showing'
              |
              translate }} {{substitutions ? substitutions.length : '0'}} {{'Substitution.title'|translate}} </span>
          </p-header>
          <p-table [value]="substitutions" sortField="name" sortOrder="1" [paginator]="false">
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="state">{{'Substitution.state'|translate}} <p-sortIcon field="state"></p-sortIcon>
                </th>
                <th pSortableColumn="identifier">{{'Substitution.identifier'|translate}} <p-sortIcon field="identifier">
                  </p-sortIcon>
                </th>
                <th pSortableColumn="replacedUser.identifier">{{'Substitution.replacedUser'|translate}} <p-sortIcon
                    field="replacedUser.identifier"></p-sortIcon>
                </th>
                <th pSortableColumn="substituteUser.identifier">{{'Substitution.substituteUser'|translate}} <p-sortIcon
                    field="substituteUser.identifier"></p-sortIcon>
                </th>
                <!-- <th pSortableColumn="cause">{{'Substitution.cause'|translate}} <p-sortIcon field="cause"></p-sortIcon>
                </th> -->
                <th pSortableColumn="cause">{{'Substitution.startDate'|translate}} <p-sortIcon field="cause">
                  </p-sortIcon>
                </th>
                <th pSortableColumn="endDate">{{'Substitution.endDate'|translate}} <p-sortIcon field="endDate">
                  </p-sortIcon>
                </th>
                <th pSortableColumn="cause">{{'Substitution.cause'|translate}} <p-sortIcon field="cause">
                  </p-sortIcon>
                </th>


                <th pSortableColumn="cause">{{'Substitution.type'|translate}} <p-sortIcon field="type">
                  </p-sortIcon>
                </th>

                <th *ngIf="parcialSubstitutionProfile" pSortableColumn="applyProfiles">
                  {{'Substitution.applyProfiles'|translate}} <p-sortIcon field="applyProfiles">
                  </p-sortIcon>
                </th>

              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-substitution>
              <tr>
                <td><span [ngClass]="getStatusStyle(substitution)">{{substitution.stateTranslation}}</span></td>
                <td><span>{{substitution.identifier}}</span></td>
                <td>
                  <user [user]="substitution.replacedUser"></user> [{{substitution.replacedUser.identifier}}]
                </td>
                <td>
                  <user [user]="substitution.substituteUser"></user> [{{substitution.substituteUser.identifier}}]
                </td>
                <!-- <td>{{substitution.causeTranslation}}</td> -->
                <td>{{substitution.initDate | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                <td>{{substitution.endDate | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                <td>{{substitution.causeTranslation}}</td>
                <td>{{substitution.typeTranslation}}</td>
                <td *ngIf="parcialSubstitutionProfile">{{substitution.applyProfiles == true ? 'S' : 'N'}}</td>
                <td class="text-right action-column-2">
                  <div class="float-right btn-group d-flex justify-content-end text-right">
                    <button class="btn btn-sm btn-secondary t-action-button" (click)="viewSubstitution(substitution)"
                      title="{{ 'General.view' | translate}}">
                      <i class="fas fa-eye" aria-hidden="true"></i>
                    </button>
                    <button *ngIf="substitution.state != 'FINISHED'" class="btn btn-sm btn-secondary t-action-button"
                      (click)="editSubstitution(substitution)" title="{{ 'General.edit' | translate}}">
                      <i class="fas fa-pencil-alt" aria-hidden="true"></i>
                    </button>
                    <button class="btn btn-sm btn-secondary t-action-button" (click)="copySubstitution(substitution)"
                      title="{{ 'General.copy' | translate}}">
                      <i class="fas fa-copy" aria-hidden="true"></i>
                    </button>

                    <button class="btn btn-primary btn-sm" (click)="confirmActive(substitution)"
                      *ngIf="substitution.state === 'ACTIVE' || substitution.state === 'CREATED'"
                      title="{{'Substitution.deactivate'|translate}}">
                      <i class="fas fa-toggle-on" aria-hidden="true"></i>
                    </button>
                    <button class="btn btn-sm btn-secondary t-action-button" (click)="confirmActive(substitution)"
                      *ngIf="substitution.state === 'INACTIVE'" title="{{'Substitution.activate'|translate}}">
                      <i class="fas fa-toggle-off" aria-hidden="true"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </ng-template>

          </p-table>

        </p-panel>
      </div>
    </div>
  </div>
</div>

<!--ng-template #noSubstitutions>
  <div class="alert alert-danger m-b-xs text-ellipsis col-12 ng-star-inserted" role="alert"><span>
      <i aria-hidden="true" class="fas fa-1-5x fa-exclamation-circle m-r-md"></i>
      {{ 'Substitution.noSubstitution' | translate }}</span>
  </div>
</ng-template-->